<template>
  <div class="card">
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title is-4">Questionnaire {{ surveyResult.type }}</p>
          <p class="subtitle is-6">{{ dateAnswering(surveyResult) }}</p>
        </div>
      </div>

      <div v-if="surveyResult.userShouldHaveResult == true && pdfUrl != ''">
        <div class="content">
          A partir de vos réponses nous avons pu établir pour vous un profil
          {{ surveyResult.resultRef }}.
          <br />
          <center>
            <a
              :download="
                'Définition de fonction synthétique ' +
                surveyResult.resultRef +
                '.pdf'
              "
              :href="pdfUrl"
              target="_blank"
              >Obtenir votre fiche détaillée</a
            >
          </center>
        </div>
      </div>
      <div v-else>
        <div class="content">
          Nous avons bien sauvegardé vos réponses et établi le profil de votre
          poste. Un spécialiste va rapidement revenir vers vous afin de vous le
          présenter et le mettre en discution.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  genRadarAndDataToPdf,
  addRadarAndDataToPdf,
} from "@/services/pdfLibService";

import moment from "moment";
export default {
  data() {
    return {
      pdfUrl: "",
      resultRadar: undefined,
      radarSvg: "",
    };
  },

  mounted() {
    this.$nextTick(function () {
      setTimeout(() => {
        genRadarAndDataToPdf(this.resultRadar).then((radarSvg) => {
          this.radarSvg = radarSvg;

          setTimeout(() => {
            if (this.resultRadar != undefined) {
              addRadarAndDataToPdf(
                this.resultRadar,
                this.radarSvg,
                this.surveyResult,
                this.userName,
                this.userPosition
              ).then((pdfBytes) => {
                var url = window.URL.createObjectURL(pdfBytes);
                this.pdfUrl = url;
              });
            }
          }, 300);
        }, 100);
      });
    });
  },
  props: {
    surveyResult: {
      type: Object,
      default: () => ({
        type: "",
        result: "",
        dateAnswering: Date(),
        resultRadar: {},
      }),
    },
    userName: String,
    userPosition: String,
  },

  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    dateAnswering(surveyResult) {
      if (surveyResult.dateAnswering != undefined) {
        if (this.resultRadar != surveyResult.resultRadar) {
          this.resultRadar = surveyResult.resultRadar;
          //      this.addRadarAndDataToPdf().then((result) => (this.pdfUrl = result));
        }
        return moment(surveyResult.dateAnswering).format("DD/MM/YYYY");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
